import {
    canAccessMultiManagerNav,
    CLINIC_MARKETPLACE_PATH,
    CLINIC_SUBSCRIPTION_PATH,
    isBillingActivationPending,
    isClinicManager,
    THERAPIST_MARKETPLACE_PATH,
} from "@/domains/multi/clinicMemberPaths";
import { useAuth } from "@/domains/shared/hooks/useAuth";
import { Navigate, Outlet, useLocation } from "react-router";

/** Redirects clinic members away from solo Marketplace deep links (**BR-35**). */
export default function ClinicMemberSoloRouteGuard() {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-[40vh] flex items-center justify-center">
                <div className="h-10 w-10 border-2 border-border border-t-primary rounded-full animate-spin" />
            </div>
        );
    }

    if (!user?.activeClinicId) {
        return <Outlet />;
    }

    const normalized = location.pathname.replace(/\/+$/, "");
    const isSoloMarketplace = normalized === THERAPIST_MARKETPLACE_PATH;

    if (!isSoloMarketplace) {
        return <Outlet />;
    }

    if (canAccessMultiManagerNav(user)) {
        return <Navigate to={`${CLINIC_MARKETPLACE_PATH}${location.search}${location.hash}`} replace />;
    }

    if (isClinicManager(user) && isBillingActivationPending(user)) {
        return <Navigate to={`${CLINIC_SUBSCRIPTION_PATH}?checkout=1`} replace />;
    }

    if (isClinicManager(user)) {
        return <Outlet />;
    }

    return <Navigate to="/profissional" replace />;
}
